export const getPathAndRepo = (items) => {
    const selectedFiles = [];
    items?.forEach((item) => {
        let filePath;
        let repository;
        if (item.repositoryPath) {
            // if playlist file
            [repository, filePath] = item.repositoryPath.split(':');
        }
        else {
            // if any other file or folder
            const parentPath = item.parentPath === '/' ? '/' : `${item.parentPath}/`;
            filePath = parentPath + item.name;
        }
        selectedFiles.push({
            path: filePath,
            repository: item.repository ?? repository,
            originalItem: item,
        });
    });
    return selectedFiles;
};
